/* eslint-disable max-len */
import React from "react";
import { defineMessage } from "@lingui/macro";

import { KfIcon, KF_ICONS, ICON_SIZE, ICON_STROKE } from "widgets/kficon";

const SAMLIcon = () => (
  <KfIcon icon={KF_ICONS.COLOR_KEY} size={ICON_SIZE.SIZE_16} />
);

export const EmailIcon = () => (
  <KfIcon
    icon={KF_ICONS.MAIL}
    size={ICON_SIZE.SIZE_16}
    stroke={ICON_STROKE.REGULAR}
  />
);

export const RESEND_MAIL_ALERT_CONTENT = {
  VERIFIED_USERS: defineMessage`Email addresses of the selected users are already verified`,
  VERIFIED_USER: defineMessage`Email address of the selected user is already verified`,
  INACTIVE_USERS: defineMessage`Verification email can't be sent to inactive users`,
  BOTH_ACTIVE_AND_INACTIVE: defineMessage`The selected users are either inactive or have their email addresses already verified`,
  COMBINED_USERS: defineMessage`Selected users will receive an email to verify their email addresses. Inactive users and already verified users, if any, will not receive the email. Do you want to proceed?`
};

export const PASSWORD_RESET_ALERT_CONTENT = {
  INACTIVE_STATUS: defineMessage`This action cannot be performed as reset password is only applicable for active users`,
  ACTIVE_STATUS: defineMessage`Selected users with an 'Active' user status will receive an email to reset their password. Do you want to proceed?`
};

export const TWO_FACTOR_SWITCHER = {
  Email: {
    label: defineMessage`Check your email for the six-digit authentication code`,
    otherOptions: [
      {
        value: "Authenticator",
        btnTxt: defineMessage`Use authentication app`,
        icon: SAMLIcon
      }
    ]
  },
  Authenticator: {
    label: defineMessage`Enter the six-digit code generated by your authentication app`,
    otherOptions: [
      {
        value: "Email",
        btnTxt: defineMessage`Get code by email`,
        icon: EmailIcon
      }
    ]
  }
};

export const TWO_FACTOR_STATUS_TOAST = {
  Mandatory: defineMessage`2FA enrollment made mandatory for the selected user(s)`,
  Recommended: defineMessage`2FA enrollment recommended for the selected user(s)`,
  Disable: defineMessage`2FA enrollment disabled for the selected user(s)`
};
